import { env } from 'next-runtime-env';

export const DEFAULT_IMG = `${env(
  'NEXT_PUBLIC_IMAGE_SERVICE_URL',
)}/images/fallback/coming-soon.webp`;
